
import axios from 'axios'
import { mapState, mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import cloneDeep from 'lodash/cloneDeep'
import RouteService from '@/services/route.service'
import SearchMixin from '@/components/offer/SearchMixin'
import SelectBrand from '@/components/input/SelectBrand'

export default {
  name: 'SearchBar2',
  components: { SelectBrand, Multiselect },
  mixins: [SearchMixin],
  computed: {
    ...mapState('layout', ['currentCountry']),
    ...mapGetters({
      getFilters: 'search/getFilters',
      getArms: 'search/getArms'
    }),
  },
  data () {
    return {
      defaultLocations: [
        { name: this.$t('searchBlock.location.nearMe'), type: 'near_me' },
        { name: this.$t('searchBlock.location.allFR'), type: 'country', value: 'FR' },
        { name: this.$t('searchBlock.location.allBE'), type: 'country', value: 'BE' },
        { name: this.$t('searchBlock.location.allCH'), type: 'country', value: 'CH' },
        { name: this.$t('searchBlock.location.allLU'), type: 'country', value: 'LU' },
        { name: this.$t('searchBlock.location.world'), type: 'all' },
      ],
      categories: [],
      filterIsOpen: false,
      filters: {
        q: '',
        minPrice: null,
        maxPrice: null,
        // category: null,
        arms: {
          foil: false,
          epee: false,
          saber: false
        }
      },
      inputLocation: null,

      locations: [],
      locationSearchLoading: false,
    }
  },
  created () {
    this.fetchCategories()
    this.setFilters()
    this.locations = this.defaultLocations
  },
  watch: {
    'getFilters' () {
      this.setFilters()
    },
    'inputLocation' (val) {
      if (!val || !val.type) return

      if (val.type === 'near_me') {
        this.locationSearchLoading = true
        window.navigator.geolocation.getCurrentPosition(({ coords }) => {
          this.locationSearchLoading = false
          this.setLocation({
            // addressLabel: val.name,
            ltype: 'near_me',
            lat: coords.latitude,
            lon: coords.longitude,
          })
        }, (err) => {
          console.error(err)
          if (err.code === 1) {
            this.$toastError({ title: 'Vous avez refusé de partager votre position' })
          } else {
            this.$toastError({ title: 'Impossible de récupérer votre position' })
          }
          this.inputLocation = ''
        })
      }

      // if (val.type === 'city') {
      //   this.setLocation({
      //     addressLabel: val.name,
      //     ltype: 'city',
      //     lat: val.coords[1],
      //     lon: val.coords[0],
      //   })
      // }

      if (val.type === 'country') {
        this.setLocation({
          ltype: 'country',
          countries: [val.value],
        })
      }

      if (val.type === 'all') {
        this.setLocation({
          ltype: 'all',
        })
      }
    }
  },
  methods: {
    async asyncFind (query) {
      this.locationSearchLoading = true

      try {
        const res = await axios.get('https://api-adresse.data.gouv.fr/search/?type=municipality&autocomplete=1&q=' + query)
        this.locations = res.data?.features.map((o, n) => ({
          ...o.properties,
          coords: o.geometry.coordinates,
          type: 'city',
        })) || []
      } catch (e) {
        this.locations = this.defaultLocations
      }

      this.locationSearchLoading = false
    },

    setFilters () {
      const { countries, ltype } = this.getFilters
      if (ltype === 'country') {
          this.inputLocation = this.defaultLocations.find(l => l.type === 'country' && l.value === countries[0])
      } else if (ltype === 'near_me') {
        this.inputLocation = this.defaultLocations.find(l => l.type === 'near_me')
      } else if (ltype === 'all') {
        this.inputLocation = this.defaultLocations.find(l => l.type === 'all')
      } else {
        this.inputLocation = this.defaultLocations.find(l => l.type === 'country' && l.value === this.currentCountry)
      }

      this.filters = { ...this.filters, ...cloneDeep(this.getFilters) }

      if (this.filters.arms.foil
        || this.filters.arms.epee
        || this.filters.arms.saber
        || this.filters.minPrice
        || this.filters.maxPrice
        || this.filters.brand
        || this.filters.brands
      ) {
        this.filterIsOpen = true
      }
    },
    async handleSearch () {
      this.search2(this.filters)
    },
    // async reset () {
    //   await this.resetFilters()
    //   this.$emit('search', true)
    // },
    async fetchCategories () {
      try {
        const { data } = await RouteService.getCategories()
        this.categories = data.categories.filter(category => category.depends.length > 0).sort((a, b) => a.order - b.order)
        this.categories.forEach(cat => cat.depends.sort((a, b) => a.order - b.order))
      } catch (e) {
        // Nothing
      }
    },
    setLocation ({ lat, lon, addressLabel, city, countries, ltype }) {
      this.filters = {...this.filters, lat, lon, addressLabel, city, countries, ltype }
    }
  },
}

